import { Component, OnInit, Input, OnDestroy, EventEmitter, Output } from '@angular/core';
import { Flight, BookedTrip } from '@ibe/models';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable, combineLatest, Subject, Subscription } from 'rxjs';
import { takeWhile } from 'rxjs/operators';

import { SidebarService } from '@ibe/services/ui';
import { INDRABookingService } from '@ibe.services/booking.indra.service';


import { TRANSLATION_ADD_MORE_MODULE,
		TRANSLATION_ANCILLARY_TEXTS,
		TRANSLATION_ANCILLARY_ARIA_LABEL, 
		ANCILLARY_PRODUCT_MEAL,
		EXTRAS_ANCILLARY_MEAL} from '@ibe.config';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';

@Component({
	selector: 'app-flights-navigation',
	templateUrl: './flights-navigation.indra.component.html',
	styleUrls: ['./flights-navigation.component.scss']
})
export class INDRAFlightsNavigationComponent implements OnInit, OnDestroy {

	@Input() ancillaryType?: any;
	@Input() flight?: any;
	@Input() selectedStop?: any;
	@Output() setSelectedSegmentStop = new EventEmitter<any>();

	@Input() skipLastSegment?: Subject<any>;
	@Input() options?: Array<any> = [];

	flightIdentifier: string;
	flights: Flight[];
	booking: BookedTrip;

	flightCardId;
	isAlive: boolean = true;
	sidebar: string;
	flightAncillaryDetails: any;
	hasNextSegment: boolean = false;
	hasPreviousSegment: boolean = false;
	skipEmptyAncSegment: Subscription;

	constructor(
		protected route: ActivatedRoute,
		protected router: Router,
		private bookingService: INDRABookingService,
		private sidebarService: SidebarService,
		private bfmStorage: INDRABFMDataStorageService
	) {
	}

	ngOnInit() {
		this.route.params
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(routeParams => {
				if (routeParams) {
					this.flightCardId = routeParams.flight;
				}
			});

		this.route.url
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value =>
				this.sidebar = value[0].path
			);

		this.flightAncillaryDetails = this.bfmStorage.INDRA_getAncillariesPerFlight();

		if (this.ancillaryType === EXTRAS_ANCILLARY_MEAL) {
			this.skipEmptyAncSegment = this.skipLastSegment.subscribe(skip => {
				if (skip && skip === 'next') {
					if (this.INDRA_hasNextFlight) {
						this.hasNextSegment = false;
						this.flightCardId = this.route.snapshot.paramMap.get('flight');
						this.INDRA_handleNext();
					}
	
				} else if (skip && skip === 'previous') {
					if (this.INDRA_hasPreviousFlight) {
						this.hasPreviousSegment = false;
						this.flightCardId = this.route.snapshot.paramMap.get('flight');
						this.INDRA_handlePrevious();
					}
				}
			});
		}
		
	}

	ngOnDestroy() {
		this.isAlive = false;
		if (this.skipEmptyAncSegment && this.ancillaryType === EXTRAS_ANCILLARY_MEAL) this.skipEmptyAncSegment.unsubscribe();
	}

	/**
	 * Handles next flight click;
	 */
	INDRA_handleNext() {
		/*
		if (this.bookingService.hasBookedFlight(this.flightIdentifier)) {
			this.flight = this.bookingService.getNextBookedFlight(this.flight.id);
		} else {
			const booking = this.mybService.getBookingFromFlightId(
				this.flightIdentifier
			);
			if (booking) {
				const index = booking.flights.findIndex(
					flight => flight.id === this.flightIdentifier
				);
				this.flight = booking.flights[(index + 1) % booking.flights.length];
			}
		}

		if (this.flight) {
			this.router.navigate([
				{ outlets: { sidebar: [this.sidebar, { flight: this.flight.id }] } }
			]);
		}
		*/
		if (this.hasNextSegment && this.ancillaryType == EXTRAS_ANCILLARY_MEAL) {
			this.setSelectedSegmentStop.emit(this.selectedStop + 1);
		} else {
			const nextFlightIdentifier = this.bookingService.INDRA_getNextFlightCardId(this.flightCardId);
			if (nextFlightIdentifier > 0) {
				this.router.navigate([
					{ outlets: { sidebar: [this.sidebar, { flight: nextFlightIdentifier}] } }
				]);
			} else {
				this.INDRA_handleClose();
			}
		}
	}

	INDRA_hasNextFlight() {
		if (this.ancillaryType) {

			if (this.ancillaryType == ANCILLARY_PRODUCT_MEAL) {
				if (this.flight.listSegment[this.selectedStop + 1] && !this.options[this.selectedStop + 1].disableButton) {
					this.hasNextSegment = true;
					return true;
				} else {
					this.hasNextSegment = false;
				}
			}

			if (this.bookingService.INDRA_hasNextFlight(this.flightCardId)) {
				const nextFlightIdentifier = this.bookingService.INDRA_getNextFlightCardId(this.flightCardId);
				if (nextFlightIdentifier > 0) {
					return this.INDRA_checkAncillaries(nextFlightIdentifier);
				}
			}
			return false;

		}

		return this.bookingService.INDRA_hasNextFlight(this.flightCardId);
	}

	/**
	* Handles previous flight click;
	*/
	INDRA_handlePrevious() {

		if (this.hasPreviousSegment && this.ancillaryType == EXTRAS_ANCILLARY_MEAL) {
			this.setSelectedSegmentStop.emit(this.selectedStop - 1);
		} else {
			const previousFlightIdentifier = this.bookingService.INDRA_getPreviousFlightCardId(this.flightCardId);
			if (previousFlightIdentifier >= 0) {
				this.router.navigate([
					{ outlets: { sidebar: [this.sidebar, { flight: previousFlightIdentifier}] } }
				]);
			} else {
				this.INDRA_handleClose();
			}
		}
	}

	INDRA_hasPreviousFlight() {
		if (this.ancillaryType) {

			if (this.ancillaryType == ANCILLARY_PRODUCT_MEAL) {
				if (this.flight.listSegment[this.selectedStop - 1] && !this.options[this.selectedStop - 1].disableButton) {
					this.hasPreviousSegment = true;
					return true;
				} else {
					this.hasPreviousSegment = false;
				}
			}

			if (this.bookingService.INDRA_hasPreviousFlight(this.flightCardId)) {
				const previousFlightIdentifier = this.bookingService.INDRA_getPreviousFlightCardId(this.flightCardId);
				if (previousFlightIdentifier > 0) {
					return this.INDRA_checkAncillaries(previousFlightIdentifier);
				}
			}
			return false;
		}

		return this.bookingService.INDRA_hasPreviousFlight(this.flightCardId);
	}

	INDRA_getTextTranslation(lastKey: string) {
		return (TRANSLATION_ADD_MORE_MODULE + TRANSLATION_ANCILLARY_TEXTS + lastKey);
	}

	INDRA_getAriaLabelTranslation(lastKey: string) {
		return (TRANSLATION_ADD_MORE_MODULE + TRANSLATION_ANCILLARY_ARIA_LABEL + lastKey);
	}

	INDRA_handleClose() {
		this.sidebarService.closeSidebar();
		this.router.navigate([{ outlets: { sidebar: null } }], { replaceUrl: true });
	}

	INDRA_checkAncillaries(otherFlightIdentifier) {
		const otherFlight = this.bookingService.INDRA_getBookedFlight(otherFlightIdentifier.toString());
		for (const i in this.flightAncillaryDetails) {
			if (this.flightAncillaryDetails[i].flightDetails) {
				if (otherFlight.assignedFlightId == this.flightAncillaryDetails[i].flightDetails.assignedFlightId &&
					otherFlight.idFlight == this.flightAncillaryDetails[i].flightDetails.idFlight &&
					otherFlight.idFlightAvail == this.flightAncillaryDetails[i].flightDetails.idFlightAvail) {
						if (this.flightAncillaryDetails[i].includedAncillaries.includes(this.ancillaryType)) {
							return true;
						}
					}
			}
		}

		return false;
	}
}
